// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z5K_","top":"styles_top__FbJEi","left":"styles_left__21_sa","description":"styles_description__3dpkg"};